var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolsFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM12 5.75C14.4686 5.75 16.4699 7.75123 16.4699 10.2199C16.4699 12.4329 14.8616 14.2704 12.75 14.6271V16.1747H13.9157C14.3299 16.1747 14.6657 16.5105 14.6657 16.9247C14.6657 17.3389 14.3299 17.6747 13.9157 17.6747H12.75V18.5211C12.75 18.9353 12.4142 19.2711 12 19.2711C11.5858 19.2711 11.25 18.9353 11.25 18.5211V17.6747H10.0843C9.67012 17.6747 9.33434 17.3389 9.33434 16.9247C9.33434 16.5105 9.67012 16.1747 10.0843 16.1747H11.25V14.6271C9.13843 14.2704 7.53012 12.4329 7.53012 10.2199C7.53012 7.75123 9.53135 5.75 12 5.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolsFemale);
export default __webpack_public_path__ + "static/media/symbols-female.c03c7743feb1bb5ec20503459d002047.svg";
export { ForwardRef as ReactComponent };